import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class meiCanoneZeroGASPlusPlus {
  public static offerta(): Offerte {
    return {
		Flg_Indicizzato: false,
      Id_Offerta: 309,
      Id_Foritore: 3,
      Id_comodity: 2,
      TipoContratto: 1,
      NomeOfferta: "CANONE ZERO GAS++",
      LinkFoto: "./assets/images/offerte-mei/canone-zero-GASPlusPlus.jpg",
      LinkFotoLarge: "./assets/images/offerte-mei/canone-zero-GASPlusPlus.jpg",
      LinkFotoMid: "./assets/images/offerte-mei/canone-zero-GASPlusPlus.jpg",
      LinkFotoSm: "./assets/images/offerte-mei/canone-zero-GASPlusPlus.jpg",
      LinkFotoCarousel: "./assets/images/offerte-mei/canone-zero-GASPlusPlus.jpg",
      DescrizioneCarousel: "Che Offerta super",
      DescrizioneNomeOfferta: "L’offerta luce e gas che rispetta l’ambiente",
      PromozioneOfferta: "",
      Sezioni: [
        {
          NomeSezione: "VANTAGGI ASSICURATI",
          DescrizioneSezione: "45€ di SCONTO ANNUALE",
          lstPunti: ["BLOCCATO 12 MESI"]
        },

      ],
      PrezzoEle: 0.0,
      PrezzoGas: 0.3390,

      TitoloPlus: "VANTAGGI ASSICURATI",
      Plus: ["45€ di SCONTO ANNUALE"]
      , schedaconfrontabilitaele:
      {
        tabellaConfrontabilita: []
      }
      , schedaconfrontabilitagas: {
        tabellaConfrontabilita: [
          { zona: 1, consumoannuo: 120, importo: 187.54 },
          { zona: 1, consumoannuo: 480, importo: 319.08 },
          { zona: 1, consumoannuo: 700, importo: 488.23 },
          { zona: 1, consumoannuo: 1400, importo: 841.16 },
          { zona: 1, consumoannuo: 2000, importo: 1141.88 },
          { zona: 1, consumoannuo: 5000, importo: 2642.23 },
          { zona: 2, consumoannuo: 120, importo: 177.78 },
          { zona: 2, consumoannuo: 480, importo: 300.30 },
          { zona: 2, consumoannuo: 700, importo: 464.28 },
          { zona: 2, consumoannuo: 1400, importo: 800.76 },
          { zona: 2, consumoannuo: 2000, importo: 1087.34 },
          { zona: 2, consumoannuo: 5000, importo: 2516.97 },
          { zona: 3, consumoannuo: 120, importo: 179.44 },
          { zona: 3, consumoannuo: 480, importo: 321.38 },
          { zona: 3, consumoannuo: 700, importo: 496.3 },
          { zona: 3, consumoannuo: 1400, importo: 867.58 },
          { zona: 3, consumoannuo: 2000, importo: 1184.07 },
          { zona: 3, consumoannuo: 5000, importo: 2763.4 },
          { zona: 4, consumoannuo: 120, importo: 192.3 },
          { zona: 4, consumoannuo: 480, importo: 344.41 },
          { zona: 4, consumoannuo: 700, importo: 524.97 },
          { zona: 4, consumoannuo: 1400, importo: 914.21 },
          { zona: 4, consumoannuo: 2000, importo: 1246.16 },
          { zona: 4, consumoannuo: 5000, importo: 2902.84 },
          { zona: 5, consumoannuo: 120, importo: 184.01 },
          { zona: 5, consumoannuo: 480, importo: 317.87 },
          { zona: 5, consumoannuo: 700, importo: 488.31 },
          { zona: 5, consumoannuo: 1400, importo: 845.36 },
          { zona: 5, consumoannuo: 2000, importo: 1149.61 },
          { zona: 5, consumoannuo: 5000, importo: 2667.64 },
          { zona: 6, consumoannuo: 120, importo: 199.45 },
          { zona: 6, consumoannuo: 480, importo: 369.64 },
          { zona: 6, consumoannuo: 700, importo: 560.25 },
          { zona: 6, consumoannuo: 1400, importo: 981.48 },
          { zona: 6, consumoannuo: 2000, importo: 1340.94 },
          { zona: 6, consumoannuo: 5000, importo: 3055.9 }
        ]
      }

      , lstModalitaPagamento: ["1", "2"]
      , scontoRid: 36
      , TipoSoglieEle: Soglie.SoglieEle4Fasce()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/meiCanoneZeroGASPlusPlus.ts